import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../customs/skeleton/main";


const Main = lazy(() => import("../../components/members/licenseRegister/main"));


const LicenseRegister = () => {

    return(
        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>    
    )
};

export default LicenseRegister;